import { AppActionTypes } from './action.type';
import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import { ProfileReducer, IProfileState } from './profile.reducer';
import { Reducer, combineReducers, Store  } from 'redux';
import { FxpGlobalStoreService } from '@fxp/fxpservices';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import { IAction } from '@fxp/statemanagement';
import { RAvailStore } from './store.model';
import  dateNavigationReducer from './Slices/DateNavigationSlice';
import {useDispatch, useSelector, TypedUseSelectorHook} from 'react-redux';
import GridCellSlice from './Slices/GridCellSlice';
import assignmentDetailsReducer from './Slices/AssignmentDetailsSlice';
import notificationReducer from './Slices/MessageBarSlice';
let appStore: Store<RootState, IAction<any>> = null;
let globalStore: FxpGlobalStoreService = null;

const reducers = {
  profile: ProfileReducer,
  dateNavigation: dateNavigationReducer,
  gridCell: GridCellSlice,
  assignments: assignmentDetailsReducer,
  notification: notificationReducer,
}

export const AppReducer: Reducer = combineReducers(reducers);

export const GetStore = () => appStore;
export const GetGlobalStore = () => globalStore;
export type RootState = RAvailStore;
export type AppDispatch = ReturnType<typeof setupStore>['dispatch'];
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppStore = ReturnType<typeof setupStore>;
export { reducers };
export type AppThunk<ReturnType = any> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const store = setupStore();

export const RegisterStoreWithFxp = (appName: string) => {
  globalStore = (
    FxpServiceFactory.getServiceInstance(FXPServiceCatalog.FxpGlobalStoreService)
  ) as FxpGlobalStoreService;
  // appStore = globalStore.CreateStore(appName, AppReducer, [
  //   customLoggerMiddleware,
  // ]);
  // globalStore.RegisterGlobalActions(appName, [AppActionTypes.UPDATE_PROFILE]);
};

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: AppReducer,
    preloadedState,
  });
}
